import UserTable from './user-table';
import { UserProfile } from './user-profile';

export { UserTable, UserProfile };
